import { initializeApp }  from "firebase/app" 

const firebaseConfig = {
    apiKey: "AIzaSyAIRIKViI1nb5oAwQg__x3h9hd8g6o6G9M",
    authDomain: "landing-page-4c804.firebaseapp.com",
    projectId: "landing-page-4c804",
    storageBucket: "landing-page-4c804.appspot.com",
    messagingSenderId: "897910921508",
    appId: "1:897910921508:web:d5d4eb9c55cb50ad163bb1"
  };
  

function fireload(){
    initializeApp(firebaseConfig);
  }


  export default fireload
  

